import {
  StyledButtonRow,
  StyledPopupButton,
} from "../../../styles/components/Popup.styled";
import {
  ModalBody,
  ModalDangerButton,
  ModalHeading,
  ModalText,
} from "../Lists.styled";
import { ModalShell } from "./ModalShell";

// Confirming a destructive action. Cancel comes first and takes the plain styling, so
// the tinted confirm button is never the one reached for by reflex.
export function ConfirmModal(props: {
  heading: string;
  message: string;
  confirmLabel: string;
  onConfirm: () => void;
  onClose: () => void;
}) {
  return (
    <ModalShell onClose={props.onClose}>
      <ModalBody>
        <ModalHeading>{props.heading}</ModalHeading>
        <ModalText>{props.message}</ModalText>
        <StyledButtonRow>
          <StyledPopupButton type="button" onClick={props.onClose}>
            Cancel
          </StyledPopupButton>
          <ModalDangerButton
            type="button"
            autoFocus
            onClick={() => {
              props.onConfirm();
              props.onClose();
            }}
          >
            {props.confirmLabel}
          </ModalDangerButton>
        </StyledButtonRow>
      </ModalBody>
    </ModalShell>
  );
}
